export const context = process.env.VUE_APP_BASE_SERVER_PATH;